// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class TreeType_abstract extends PersistentObject {
  static $t: string = 'SagaBase.Objects.TreeType';
  $t: string = 'SagaBase.Objects.TreeType';

  public static GetMembers(): string[] {
    return ['TreeTypeId', 'Name', 'Color', 'IsUnitSectors', 'IsVisible', 'IsFirstSectorSelectable', 'IsTopDisplay', 'AgencyIds'].concat(
      PersistentObject.GetMembers()
    );
  }

  public GetMembers(): string[] {
    return TreeType_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public TreeTypeId: number = 0;
  public Name: string;
  public Color: string;
  public IsUnitSectors: boolean = false;
  public IsVisible: boolean = false;
  public IsFirstSectorSelectable: boolean = false;
  public IsTopDisplay: boolean = false;
  public AgencyIds: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.TreeTypeId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
